import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconApps24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconApps24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.75 3.5H4a.5.5 0 0 0-.5.5v4.75a.5.5 0 0 0 .5.5h4.75a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5M4 2a2 2 0 0 0-2 2v4.75a2 2 0 0 0 2 2h4.75a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 12.75h4.75a.5.5 0 0 1 .5.5V20a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-4.75a.5.5 0 0 1 .5-.5m-2 .5a2 2 0 0 1 2-2h4.75a2 2 0 0 1 2 2V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm12.75 0a.5.5 0 0 1 .5-.5H20a.5.5 0 0 1 .5.5V20a.5.5 0 0 1-.5.5h-4.75a.5.5 0 0 1-.5-.5zm-1.5 0a2 2 0 0 1 2-2H20a2 2 0 0 1 2 2V20a2 2 0 0 1-2 2h-4.75a2 2 0 0 1-2-2zm4.375-13.062a.75.75 0 0 1 .75.75v2.687h2.688a.75.75 0 0 1 0 1.5h-2.688v2.688a.75.75 0 0 1-1.5 0V7.124h-2.687a.75.75 0 0 1 0-1.5h2.687V2.938a.75.75 0 0 1 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconApps24);
